export default function filterUrlQueryParams(url) {
  // Regular expression to match 'id' and capture its value
  const idMatch = url.match(/[?&]id=([^&]*)/);
  const idValue = idMatch ? idMatch[1] : null;

  // Get the base URL without query parameters
  const baseUrl = url.split('?')[0];

  // If 'id' exists, return the URL with only 'id'
  /* istanbul ignore else */
  if (idValue) {
    return `${baseUrl}?id=${idValue}`;
  }
  return baseUrl;
}
